// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 19902-手动触发停车场信息消息生成 POST /web/v1/message/test/parking-message */
export async function triggerParkingMessage(options?: { [key: string]: any }) {
  return request<API.YmResultVOString>("/web/v1/message/test/parking-message", {
    method: "POST",
    ...(options || {}),
  });
}

/** 19901-手动触发游泳池水质信息消息生成 POST /web/v1/message/test/pool-message */
export async function triggerPoolMessage(options?: { [key: string]: any }) {
  return request<API.YmResultVOString>("/web/v1/message/test/pool-message", {
    method: "POST",
    ...(options || {}),
  });
}
